import AddSheet from "../../components/add-sheet/add-sheet";

function AddSheetRoute() {
  return <AddSheet />;
}

export default AddSheetRoute;
